import React from "react";
import Modal from "react-modal";
import { marked } from "marked";

import { QUESTION_TYPE_IDS } from "../../../../constants";
import DetailRow from "./DetailRow";

// Modal for showing the details of reels (recap brief)
const EventDetailsModal = ({
  className,
  eventDetail,
  eventDetailId,
  isModalOpen,
  handleModalClose,
}) => {
  // Convert markdown/plain text into HTML.
  // Detects if HTML already exists to avoid double-parsing.
  const getFormattedHtml = (text = "") => {
    const isHtml = /<\/?[a-z][\s\S]*>/i.test(text);

    return {
      __html: isHtml ? text : marked.parse(text),
    };
  };

  return (
    <Modal
      isOpen={isModalOpen}
      className={className}
      onRequestClose={handleModalClose}
    >
      <div className="main-con">
        <div className="row">
              {/* Header */}
              <div className="row w-100 header">
                <div className="col-12">shot list</div>
                <div className="col-12">{eventDetailId}</div>
              </div>
                {/* Details */}
                <div className="w-100 my-3">
                  <>
                    <DetailRow
                      label="event type:"
                      value={eventDetail?.eventType?.name}
                    />
                    <DetailRow
                      label="event overview:"
                      value={
                        eventDetail?.eventQuestionAnswers?.find(
                          (f) =>
                            f.questionTypeId == QUESTION_TYPE_IDS.CONTENT_USAGE
                        )?.answer ?? " "
                      }
                    />
                    {/* shot list (Markdown + HTML Support) */}
                    <div className="row w-100">
                      <div className="col-12 col-md-4 col-lg-3 col-xl-2 py-1 py-md-2 detail-row-heading">
                        event shot list:
                      </div>
                      <div
                        className="col-12 col-md-8 col-lg-9 col-xl-10 py-1 py-md-2 formatted-html"
                        dangerouslySetInnerHTML={getFormattedHtml(
                          eventDetail?.eventType?.description || ""
                        )}
                      />
                    </div>
                    <DetailRow
                      label="brand & legal requirements:"
                      value={
                        eventDetail?.eventQuestionAnswers?.find(
                          (f) =>
                            f.questionTypeId ==
                            QUESTION_TYPE_IDS.BRAND_GUIDELINES
                        )?.answer ?? " "
                      }
                    />
                  </>
                </div>
        </div>
        <button onClick={handleModalClose} className="modal-close">
          <img
            alt="crossIcon"
            className="modal-close-img"
            src="/images/simpleCrossWhite.svg"
          />
        </button>
      </div>
    </Modal>
  );
};

export default EventDetailsModal;
